// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-HZp","right":"styles_right__2W6q-"};